import { Typography } from '@material-ui/core'
import RoomIcon from '@material-ui/icons/Room'
import { FC } from 'react'

import { DestinationAutoComplete } from '../../components/DestinationAutoComplete'
import { getTranslate } from '../../localization'
import { DestinationOption } from '../../types/accommodationSubscribedToChannel'
import { SearchAvailabilityInput } from '../../types/searchAvailability'
import useStyles from './styles/SearchWidgetSearchInput.styles'

interface SearchWidgetSearchInputProps {
  options: DestinationOption[]
  setSearchAvailabilityInput: React.Dispatch<
    React.SetStateAction<SearchAvailabilityInput>
  >
  searchAvailabilityInput: SearchAvailabilityInput
  loadingForAccommodation: boolean
}
const SearchWidgetSearchInput: FC<SearchWidgetSearchInputProps> = ({
  options,
  setSearchAvailabilityInput,
  loadingForAccommodation,
  searchAvailabilityInput
}) => {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <div className={classes.destinationHeader}>
        <RoomIcon className={classes.icon} />
        <Typography variant="h6" className={classes.title}>
          {getTranslate('Destination')}
        </Typography>
      </div>
      <div className={classes.destinationAutoComplete}>
        <DestinationAutoComplete
          options={options}
          searchAvailabilityInput={searchAvailabilityInput}
          setSearchAvailabilityInput={setSearchAvailabilityInput}
          loadingForAccommodation={loadingForAccommodation}
        />
      </div>
    </div>
  )
}
export default SearchWidgetSearchInput
